module.exports = __webpack_public_path__ + "fonts/MyriadPro-SemiBoldIt.70e8bfb4.otf";